import React, { useEffect, useRef, useState } from 'react';
import { PhotoIcon } from '@heroicons/react/24/solid';

const HeaderUpload = ({ headerContent }) => {
  const [changePicture, setChangePicture] = useState(!headerContent);
  // Image Preview
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState();
  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }
    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  return (
    <div className="sm:col-span-6">
      <div className="block text-sm font-medium leading-6 text-gray-900">
        Header hochladen
      </div>

      {changePicture ? (
        <div className="mt-2">
          <div className="mt-4 flex text-sm leading-6 text-gray-600">
            <button
              type="button"
              className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 ring-1 ring-inset ring-gray-300"
            >
              <label
                htmlFor="headerContent"
                className="relative cursor-pointer "
              >
                Eine Datei hochladen
              </label>
            </button>
            {/* <input
                id="headerContent"
                name="headerContent"
                type="file"
                accept="image/*"
                className="sr-only"
                onChange={(e) => {
                  onSelectFile(e);
                  setChangePicture(false);
                }}
              /> */}
          </div>
          <p className="text-xs leading-5 text-gray-600 mt-2">
            JPG, PNG oder WebP bis maximal 10MB
          </p>
        </div>
      ) : (
        <div className="max-w-2xl">
          <div className="aspect-w-2 aspect-h-1">
            <img
              src={selectedFile ? preview : headerContent}
              alt="header"
              className="h-full w-full flex-none rounded-lg bg-gray-800 object-cover"
            />
          </div>
          <button
            type="button"
            className="rounded-md mt-2 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 ring-1 ring-inset ring-gray-300"
            onClick={setChangePicture}
          >
            Bild ändern
          </button>
        </div>
      )}
      <input
        id="headerContent"
        name="headerContent"
        type="file"
        accept="image/*"
        className="sr-only"
        onChange={(e) => {
          onSelectFile(e);
          setChangePicture(false);
        }}
      />
    </div>
  );
};

export default HeaderUpload;
